import { useState, useEffect } from 'react';

const QUERY = '(prefers-reduced-motion: no-preference)';

/**
 * Checks if the current environment is the server.
 * This can be helpful in SSR (Server-Side Rendering) to avoid accessing window object directly
 * during the server render.
 */
const isRenderingOnServer = typeof window === 'undefined';

/**
 * Get the initial state based on whether the component is being rendered on the server
 * or the client. We rely on matchMedia on the client and default to true on the server.
 */
const getInitialState = () =>
  isRenderingOnServer ? true : !window.matchMedia(QUERY).matches;

function usePrefersReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(getInitialState);

  useEffect(() => {
    if (isRenderingOnServer) return; // Skip running this effect on the server-side render

    // Use matchMedia to check for prefers-reduced-motion
    const mediaQueryList = window.matchMedia(QUERY);

    const listener = (event) => {
      // Set the state based on whether reduced motion is preferred or not
      setPrefersReducedMotion(!event.matches);
    };

    // Add event listener for changes in prefers-reduced-motion media query
    mediaQueryList.addEventListener('change', listener);

    // Clean up the listener on component unmount or when the effect reruns
    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, []); // Empty dependency array means this effect runs once after the first render

  return prefersReducedMotion;
}

export default usePrefersReducedMotion;
